import * as React from 'react';
import { getKeys, getMods, isff } from './utils';
import { keyMap, modifier } from './var';

const code = (x: string) =>
  keyMap[x.toLowerCase()] ||
  modifier[x.toLowerCase()] ||
  x.toUpperCase().charCodeAt(0);

export interface HotKeysProps {
  filterTag?: string[]; // 'INPUT' || 'SELECT' || 'TEXTAREA' || 'isContentEditable'
  keys: string;
  onKeyDown: (
    e: React.KeyboardEvent<HTMLElement>,
    handle: any
  ) => void | boolean;
  children: React.ReactNode;
}

interface HotKeysState {
  downKeys: number[]; // 记录摁下的绑定键
  keys: string[];
  handlers: { [key: string]: any };
  hotkeys: { [key: string]: any };
  mods: { [key: string]: boolean };
}

export class HotKeys extends React.Component<HotKeysProps, HotKeysState> {
  $scope: HTMLElement = document.body;
  state: HotKeysState = {
    downKeys: [],
    keys: [],
    handlers: {},
    hotkeys: {},
    mods: {
      16: false,
      18: false,
      17: false
    }
  };

  componentDidMount() {
    this.onInit();
  }

  render() {
    return (
      <div
        className="hot-key-wrap"
        ref={this.hotkeyScopeRef}
        onKeyDown={(e: React.KeyboardEvent<HTMLDivElement>) => {
          this.dispatch(e);
        }}
        onKeyUp={(e: React.KeyboardEvent<HTMLDivElement>) => {
          this.clearModifier();
        }}
      >
        {this.props.children}
      </div>
    );
  }

  onInit = () => {
    const state = this.state;
    const props = this.props;

    state.mods[isff ? 224 : 91] = false;

    const keys = getKeys(props.keys); // ['alt+a', 'alt+b', 'c']

    for (const [i, key] of keys.entries()) {
      let curKey: any = keys[i].split('+'); // 按键列表 ['alt', 'a']
      let mods: string[] = [];

      if (key.length > 1) {
        mods = getMods(modifier, curKey); // ['alt']
      }
      curKey = code(curKey[curKey.length - 1]); // 'a'

      if (!(curKey in state.handlers)) {
        state.handlers[curKey] = [];
      }

      /*
        {
          key: 'alt+a',
          mods: ['alt'],
          shorcut: 'a'
        }
       */
      state.handlers[curKey].push({
        mods,
        key: curKey,
        shorcut: key
      });

      this.setState({
        handlers: state.handlers,
        mods: state.mods
      });
    }
  };

  hotkeyScopeRef = (ref: any) => {
    this.$scope = ref;
  };

  isPressed = (keyCode: number) => this.state.downKeys.indexOf(keyCode) !== -1;

  dispatch = (e: React.KeyboardEvent<HTMLDivElement>) => {
    const state = this.state;
    const props = this.props;
    let key = e.keyCode || e.which || e.charCode;

    // 搜集绑定的键
    if (state.downKeys.indexOf(key) === -1) {
      state.downKeys.push(key);
    }

    // Gecko(Firefox)的command键值224，在Webkit(Chrome)中保持一致
    // Webkit左右command键值不一样
    if (key === 93 || key === 224) {
      key = 91;
    }

    if (key in state.mods) {
      state.mods[key] = true;

      // 将热键的key注册到 hotkeys 上
      for (const k in modifier) {
        if (modifier[k] === key) {
          state.hotkeys[k] = true;
        }
      }
    }

    const target: any = e.target || (e as any).srcElement;
    const { tagName } = target as any;

    const filterEditable =
      props.filterTag &&
      props.filterTag.indexOf('isContentEditable') !== -1 &&
      target.isContentEditable;

    const filterTag =
      props.filterTag &&
      props.filterTag.map(
        (name: string) => name.toUpperCase().indexOf(tagName) !== -1
      );

    if (filterEditable || filterTag) {
      return;
    }

    if (!state.handlers[key]) {
      return;
    }

    for (const handler of state.handlers[key]) {
      // 找到处理内容
      this.eventHandler(e, handler);
    }
  };

  clearModifier = () => {
    const state = this.state;
    // let key = e.keyCode || e.which || e.charCode;
    // const i = state.downKeys.indexOf(key);

    // if (i >= 0) {
    //   state.downKeys.splice(i, 1);
    // }
    // // 修饰键 shiftKey altKey ctrlKey (command||metaKey) 清除
    // if (key === 93 || key === 224) {
    //   key = 91;
    // }

    state.mods = {
      16: false,
      18: false,
      17: false
    };
    state.mods[isff ? 224 : 91] = false;

    state.hotkeys = {};

    this.setState({
      ...state
    });
  };

  eventHandler = (e: React.KeyboardEvent<HTMLDivElement>, handler: any) => {
    const state = this.state;
    const props = this.props;
    let modifiersMatch = handler.mods.length > 0;

    for (const k in state.mods) {
      if (Object.prototype.hasOwnProperty.call(state.mods, k)) {
        if (
          (!state.mods[+k] && handler.mods.indexOf(+k) !== -1) ||
          (state.mods[+k] && handler.mods.indexOf(+k) === -1)
        ) {
          modifiersMatch = false;
        }
      }
    }

    if (
      (handler.mods.length === 0 &&
        !state.mods[16] &&
        !state.mods[17] &&
        !state.mods[18] &&
        !state.mods[91]) ||
      modifiersMatch
    ) {
      if (props.onKeyDown(e, handler) === false) {
        this.clearModifier();
        if (e.preventDefault) {
          e.preventDefault();
        } else {
          (e as any).returnValue = false;
        }
        if (e.stopPropagation) {
          e.stopPropagation();
        }
        if ((e as any).cancelBubble) {
          (e as any).cancelBubble = true;
        }
      }
    }
  };
}
